import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-modal-ticket',
  templateUrl: './modal-ticket.component.html',
  styleUrls: ['./modal-ticket.component.scss']
})
export class ModalTicketComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalTicketComponent>) { }

  ngOnInit() {
  }

  imprimir() {
    this.dialogRef.close(true);
  }

  continuar() {
    this.dialogRef.close(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/pago-venta/modal-ticket/modal-ticket.component.ts